/*
 * Sell mode (2026-10-08) — free shipping meter + one-tap sock pair.
 * Spec: specs/sections/sell-mode-2026-10-08.md. Markup: snippets/sell-mode-meter.liquid.
 *
 * Vanilla JS, no theme internals beyond the two the theme exposes for this:
 *  - window.cart.getCart() rebuilds the cart drawer, count and progress, fires
 *    theme:cart:added and opens the drawer (assets/theme.dev.js CartDrawer).
 *  - theme:cart:added / theme:cart:loaded tell us the cart changed.
 * Clicks are delegated from document, so a meter re-rendered inside the cart
 * drawer by the theme's AJAX refresh keeps working without re-binding.
 */
(function () {
  'use strict';
  if (window.__sellMeterInit) return;
  window.__sellMeterInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartState = null;
  var userPickedSockSize = false;

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // Shoe size label -> sock size, from 2,537 shoe + sock co-purchases since 2025-01-01.
  function sockSizeFor(label) {
    if (!label) return null;
    var t = String(label).trim();
    if (/^y\s*\d/i.test(t)) return 'S';
    var n = parseFloat(t.replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return null;
    if (n < 7) return 'S';
    if (n < 9.5) return 'M';
    return 'L';
  }

  function meters() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sell-meter]'));
  }

  function render() {
    if (!cartState) return;
    meters().forEach(function (m) {
      var threshold = parseInt(m.dataset.threshold, 10) || 0;
      if (!threshold) return;
      var pid = m.dataset.productId ? parseInt(m.dataset.productId, 10) : null;
      var price = parseInt(m.dataset.productPrice, 10) || 0;
      var inCart = pid ? cartState.items.some(function (i) { return i.product_id === pid; }) : true;
      var projected = cartState.total_price + (inCart ? 0 : price);
      var gap = threshold - projected;
      var pct = Math.max(4, Math.min(100, Math.round((projected / threshold) * 100)));
      var unlocked = gap <= 0;

      var text = m.querySelector('[data-sell-meter-text]');
      var fill = m.querySelector('[data-sell-meter-fill]');
      var empty = !pid && cartState.item_count === 0;
      if (text) {
        text.textContent = unlocked ? 'This order ships free'
          : empty ? 'Free shipping on orders over ' + money(threshold).replace(/\.00$/, '')
          : money(gap) + ' away from free shipping';
      }
      if (fill) fill.style.transform = 'scaleX(' + (empty ? 0 : pct / 100) + ')';
      m.classList.toggle('is-unlocked', unlocked);
      m.classList.toggle('is-empty', empty);

      // The title only promises free shipping when the pair alone gets the order there.
      var pair = parseInt(m.dataset.pairTotal, 10) || 0;
      var title = m.querySelector('[data-sell-meter-title]');
      if (title) title.textContent = gap > 0 && gap <= pair ? 'Add socks, ship free' : title.dataset.defaultTitle;

      // In the cart the offer only shows while it can still do its job.
      if (m.classList.contains('sell-meter--cart')) m.hidden = unlocked || cartState.item_count === 0;
    });
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; render(); })
      .catch(function () {});
  }

  function setSockSize(m, size) {
    Array.prototype.forEach.call(m.querySelectorAll('[data-sock-size]'), function (b) {
      b.setAttribute('aria-checked', String(b.dataset.sockSize === size));
    });
  }

  function chosenSockSize(m) {
    var b = m.querySelector('[data-sock-size][aria-checked="true"]');
    return b ? b.dataset.sockSize : 'M';
  }

  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest && e.target.closest('[data-sock-size]');
    if (sizeBtn) {
      var m1 = sizeBtn.closest('[data-sell-meter]');
      userPickedSockSize = true;
      setSockSize(m1, sizeBtn.dataset.sockSize);
      return;
    }

    var add = e.target.closest && e.target.closest('[data-sell-meter-add]');
    if (!add) return;
    var m = add.closest('[data-sell-meter]');
    var dataEl = m.querySelector('[data-sell-meter-socks]') || document.querySelector('[data-sell-meter-socks]');
    var socks = [];
    try { socks = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var size = chosenSockSize(m);
    var items = socks.map(function (s) {
      var id = s.map[size] || s.map.M || s.map[Object.keys(s.map)[0]];
      return id ? { id: id, quantity: 1 } : null;
    }).filter(Boolean);
    if (!items.length) return;

    add.disabled = true;
    add.textContent = 'Adding';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        add.textContent = 'Added';
        add.classList.add('is-added');
        if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
        return refresh();
      })
      .catch(function () {
        add.disabled = false;
        add.textContent = 'Add both';
      });
  });

  // Preselect the sock size from the shoe size the customer picks, until they choose one.
  document.addEventListener('change', function (e) {
    if (userPickedSockSize) return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('.radio__fieldset--size .radio__input')) return;
    var btn = input.closest('.radio__button');
    var label = btn && btn.querySelector('.option-title');
    var size = sockSizeFor(label ? label.textContent : input.value);
    if (!size) return;
    meters().forEach(function (m) { setSockSize(m, size); });
  });

  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { refresh(); });
  });

  // The cart drawer re-renders its line items over AJAX; re-paint any meter it brings back.
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var nodes = list[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && (n.matches('[data-sell-meter]') || n.querySelector('[data-sell-meter]'))) {
          render();
          return;
        }
      }
    }
  });

  function start() {
    mo.observe(document.body, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
